class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this._openTimer = null;

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code && event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const note = this.querySelector('[id^="Details-"] summary');
    if (note && !note.hasAttribute('role')) {
      this.setSummaryAccessibility(note);
    }

    requestAnimationFrame(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const container =
          this.querySelector('#CartDrawer') ||
          this.querySelector('.drawer__inner-empty') ||
          this.querySelector('.drawer__inner');

        const focusEl =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        if (container && focusEl) {
          trapFocus(container, focusEl);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(note) {
    note.setAttribute('role', 'button');
    note.setAttribute('aria-expanded', 'false');

    const sibling = note.nextElementSibling;
    if (sibling && sibling.id) {
      note.setAttribute('aria-controls', sibling.id);
    }

    note.addEventListener('click', (event) => {
      const isOpen = event.currentTarget.closest('details').hasAttribute('open');
      event.currentTarget.setAttribute('aria-expanded', !isOpen);
    });

    note.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    // empty state
    this.classList.toggle('is-empty', parsedState.item_count === 0);

    // actually swap in the fresh section HTML
    this.getSectionsToRender().forEach((section) => {
      if (!parsedState.sections || !parsedState.sections[section.id]) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // prevent multiple rapid openings
    clearTimeout(this._openTimer);

    this._openTimer = setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.removeEventListener('click', this.close.bind(this));
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    }, 10);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const target = parsed.querySelector(selector);
    return target ? target.innerHTML : html;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);